import { Link, Navigate } from "react-router-dom";
import { Lock, UserPlus, ArrowRight } from "lucide-react";
import SEO from "../../components/SEO";
import PageHeader from "../../components/PageHeader";
import { Reveal } from "../../components/Reveal";
import { useAuth } from "../../context/AuthContext";

export default function EspaceHome() {
  const { user, loading } = useAuth();

  if (!loading && user?.role === "licencie") {
    return <Navigate to="/espace/tableau-de-bord" replace />;
  }

  return (
    <>
      <SEO title="Espace Licencié" description="Votre espace personnel au sein du Club Cycliste Le Boulou." />
      <PageHeader kicker="Membres" title="Espace Licencié" />

      <section className="py-16 sm:py-24 bg-mist">
        <div className="max-w-[1100px] mx-auto px-5 sm:px-8">
          <Reveal>
            <p className="text-steel text-base sm:text-lg max-w-2xl mb-8" data-testid="espace-subtitle">
              Votre espace personnel au sein du Club Cycliste Le Boulou.
            </p>
          </Reveal>

          <Reveal delay={0.05}>
            <div className="mb-14 bg-white border-l-2 border-rouge p-6 sm:p-8 flex flex-wrap items-center justify-between gap-5" data-testid="espace-premiere-connexion">
              <div>
                <p className="font-heading uppercase font-semibold tracking-tight text-navy text-xl">Première connexion ?</p>
                <p className="mt-1 text-sm text-steel">
                  Vous êtes licencié au club et n'avez pas encore d'accès ? Créez-le avec votre email ou votre numéro de licence FFC.
                </p>
              </div>
              <Link
                to="/espace/creer-acces"
                data-testid="espace-goto-creer-acces"
                className="inline-flex items-center gap-3 bg-navy text-white font-heading uppercase tracking-wider text-sm px-8 py-4 hover:bg-rouge transition-colors duration-300"
              >
                Créer mon accès
                <ArrowRight size={16} />
              </Link>
            </div>
          </Reveal>

          <div className="grid md:grid-cols-2 gap-6">
            <Reveal delay={0.1}>
              <div className="bg-navy text-white p-8 sm:p-12 flex flex-col h-full" data-testid="espace-card-member">
                <div className="w-14 h-14 bg-rouge flex items-center justify-center mb-8">
                  <Lock size={24} />
                </div>
                <h2 className="font-heading uppercase font-semibold tracking-tight text-3xl sm:text-4xl mb-4">
                  Déjà membre ?
                </h2>
                <p className="text-white/70 leading-relaxed mb-10 flex-1">
                  Accédez à votre espace personnel pour retrouver vos informations, documents et services du club.
                </p>
                <Link
                  to="/espace/connexion"
                  data-testid="espace-goto-login"
                  className="group inline-flex items-center justify-center gap-3 bg-rouge text-white font-heading uppercase tracking-wider text-sm px-8 py-4 hover:bg-white hover:text-navy transition-[background-color,color] duration-300"
                >
                  Se connecter
                  <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1.5" />
                </Link>
              </div>
            </Reveal>

            <Reveal delay={0.2}>
              <div className="bg-white border border-navy/10 p-8 sm:p-12 flex flex-col h-full" data-testid="espace-card-join">
                <div className="w-14 h-14 bg-navy flex items-center justify-center mb-8 text-white">
                  <UserPlus size={24} />
                </div>
                <h2 className="font-heading uppercase font-semibold tracking-tight text-navy text-3xl sm:text-4xl mb-4">
                  Vous souhaitez rejoindre le club ?
                </h2>
                <p className="text-steel leading-relaxed mb-10 flex-1">
                  Vous n'êtes pas encore membre ? Inscrivez-vous directement en ligne.
                </p>
                <Link
                  to="/rejoindre"
                  data-testid="espace-goto-join"
                  className="group inline-flex items-center justify-center gap-3 border-2 border-navy text-navy font-heading uppercase tracking-wider text-sm px-8 py-4 hover:bg-navy hover:text-white transition-[background-color,color] duration-300"
                >
                  S'inscrire au club
                  <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1.5" />
                </Link>
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
}
